import { CarbonDateTime } from './HococoInterfaces';

export default class CorporationLinkData {
    public id: number;
    public key: string;
    public languageVersions: any[];
    public createdAt: CarbonDateTime | any;
    public updatedAt: CarbonDateTime | any;

    constructor(
        id: number,
        key: string = '',
        languageVersions: any = [],
        createdAt: CarbonDateTime | any = null,
        updatedAt: CarbonDateTime | any = null,
    ) {
        this.id = id;
        this.key = key;
        this.languageVersions = languageVersions;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }

}